import { DevicesDeviceType } from '@smarthome/api';
import {
  Blinds,
  Columns2,
  Cpu,
  Fan,
  Lightbulb,
  Power,
  Speaker,
  Tv,
  type LucideIcon,
} from 'lucide-react';

/**
 * Map DevicesDeviceType to corresponding Lucide icon
 */
export function getDeviceIcon(type?: DevicesDeviceType, subtype?: string | null): LucideIcon {
  switch (type) {
    case DevicesDeviceType.DeviceTypeLight:
      return Lightbulb;
    case DevicesDeviceType.DeviceTypeWindowCovering:
      return subtype === 'curtain' ? Columns2 : Blinds;
    case DevicesDeviceType.DeviceTypeFan:
      return Fan;
    case DevicesDeviceType.DeviceTypeSpeaker:
      return Speaker;
    case DevicesDeviceType.DeviceTypeTV:
      return Tv;
    case DevicesDeviceType.DeviceTypeSwitch:
      return Power;
    default:
      return Cpu;
  }
}

/**
 * Get display label for device type
 */
export function getDeviceTypeLabel(type?: DevicesDeviceType): string {
  switch (type) {
    case DevicesDeviceType.DeviceTypeLight:
      return 'Light';
    case DevicesDeviceType.DeviceTypeWindowCovering:
      return 'Window covering';
    case DevicesDeviceType.DeviceTypeFan:
      return 'Fan';
    case DevicesDeviceType.DeviceTypeSpeaker:
      return 'Speaker';
    case DevicesDeviceType.DeviceTypeTV:
      return 'TV';
    case DevicesDeviceType.DeviceTypeSwitch:
      return 'Switch';
    default:
      return 'Unknown';
  }
}
